import { useHasAiInterviewerMembershipsQuery } from "../main/graphql";
import { useFeatureFlagForCurrentOrImpersonatedUser } from "../main/graphql/hooks/useFeatureFlag";
import { useBHScreenPermission } from "../main/hooks/useBHScreenPermission";

export const useAiInterviewerEnabled = (): boolean => {
  const orgFeatureEnabled =
    useFeatureFlagForCurrentOrImpersonatedUser("ai_interviewer:v1");
  const { canView } = useBHScreenPermission();
  const { data } = useHasAiInterviewerMembershipsQuery({
    skip: !orgFeatureEnabled,
  });

  if (!orgFeatureEnabled) {
    return false;
  }

  const hasGlobalViewerAccess = canView;
  const hasShares = data?.hasAiInterviewerMemberships ?? false;

  return hasGlobalViewerAccess || hasShares;
};
